import { createPortal } from 'react-dom';
import type { Exercise } from '@tg/domain';
import { ICON } from './icons';
import { Svg } from './Svg';

/* Подсказки из базы под полем названия (как .sug.exsug в прототипе).
   Заранее ничего не выбрано: Enter без выбора оставляет текст как написан (CON-5). */
export interface SugState {
  forId: string;
  text: string;
  list: Exercise[];
  /** -1 — ничего не выбрано */
  sel: number;
  rect: { left: number; top: number };
}

export function Suggest({ s, onPick, onNew }: { s: SugState; onPick: (e: Exercise) => void; onNew: (name: string) => void }) {
  const name = s.text.trim();
  const cap = name ? name[0].toUpperCase() + name.slice(1) : '';
  return createPortal(
    <div className="sug exsug" style={{ left: s.rect.left, top: s.rect.top }} data-for-item={s.forId} data-text={s.text} onMouseDown={(e) => e.preventDefault()}>
      {s.list.length > 0 && <div className="cap">Из базы</div>}
      {s.list.map((e, k) => (
        <button key={e.id} className={'row' + (k === s.sel ? ' on' : '')} data-pick={e.id} onClick={() => onPick(e)}>
          <b>{e.ru}</b>
          <s>{e.groups.join(', ')}</s>
          {k === 0 && <kbd className="rk">Tab</kbd>}
        </button>
      ))}
      {name.length >= 2 && (
        <>
          <div className="cap">Нет нужного?</div>
          <button className="row newex" data-newex="" onClick={() => onNew(name)}>
            <b>
              <Svg src={ICON.plus} /> Добавить «{cap}» в базу
            </b>
            <s>будет подсказываться при наборе</s>
          </button>
        </>
      )}
      <div className="sugkeys">
        <span>
          <kbd>Tab</kbd>первое из базы
        </span>
        <span>
          <kbd>↑</kbd>
          <kbd>↓</kbd>выбрать
        </span>
        <span>
          <kbd>Enter</kbd>
          <i className="sk-ent">{s.sel >= 0 ? 'выбрать' : 'оставить текстом'}</i>
        </span>
        <span>
          <kbd>Esc</kbd>закрыть
        </span>
      </div>
    </div>,
    document.body,
  );
}

export function sugRect(el: HTMLElement) {
  const r = el.getBoundingClientRect();
  return { left: r.left + window.scrollX, top: r.bottom + window.scrollY + 4 };
}
